/** Data pre appku WSM 2021 */
export const appWSM2021Config = {
    data: undefined
};
//# sourceMappingURL=appWSM2021Config.js.map